import * as yup from "yup";

export interface OnDemandValidationFormData {
  programId: string;
  onDemandValidationDays: string;
}

const validationSchema = (programDays: number) =>
  yup.object<OnDemandValidationFormData>().shape({
    programId: yup.string().required("Program is required"),
    onDemandValidationDays: yup
      .string()
      .defined()
      .test(
        "valid-days",
        `Values must be greater than ${programDays}`,
        function (value) {
          if (!value || value.trim() === "") {
            return true; // Allow empty string (will be saved as [])
          }

          const days = value
            .split(",")
            .map((d) => d.trim())
            .filter((d) => d !== "");

          // Check all values are numeric integers
          const allNumeric = days.every((d) => /^\d+$/.test(d));
          if (!allNumeric) {
            return this.createError({
              message: "All values must be numeric",
            });
          }

          // Check all values are greater than programDays
          const allValid = days.every(
            (d) => parseInt(d, 10) > programDays && parseInt(d, 10) <= 365,
          );
          if (!allValid) {
            return this.createError({
              message: `Values must be greater than ${programDays} and lower than 366`,
            });
          }

          return true;
        },
      ),
  });

export default validationSchema;
